import { render, staticRenderFns } from "./set-role.vue?vue&type=template&id=72ef9c00"
import script from "./set-role.vue?vue&type=script&lang=js"
export * from "./set-role.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports